// Slider

/* eslint-disable no-nested-ternary */
/* eslint-disable no-invalid-this */
/* eslint-disable no-magic-numbers */
/* eslint-disable max-params */
/* eslint-disable function-name-case */

/* global jQuery */

( function( $ ) {


// $('.c-testimonial__slider').slick({
//     dots: false,
//     nextArrow: '.next',
//     prevArrow: '.previous',
//     // autoplay: true,
//     // autoplaySpeed: 10000,
//     speed: 500,
//     slidesToShow: 1,
//     slidesToScroll: 1,
//     cssEase: 'ease-in-out',
//     responsive: [
//         {
//             breakpoint: 767,
//             settings: {
//             slidesToShow: 2,
//             slidesToScroll: 1
//             }
//         },
//         {
//             breakpoint: 639,
//             settings: {
//             slidesToShow: 1,
//             slidesToScroll: 1
//             }
//         }

//         ]
// });

var slickSlide = $('.c-testimonial__slider');

slickSlide.slick({
    slide: '.c-testimonial__slide',
    dots: false,
    nextArrow: '.next',
    prevArrow: '.previous',
    // autoplay: true,
    // autoplaySpeed: 10000,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    cssEase: 'ease-in-out',
    responsive: [
        {
            breakpoint: 767,
            settings: {
            slidesToShow: 2,
            slidesToScroll: 1
            }
        },
        {
            breakpoint: 639,
            settings: {
            slidesToShow: 1,
            slidesToScroll: 1
            }
        }

        ]

});

}( jQuery ) );



// WEBPACK FOOTER //
// ./src/js/inc/slider.js